import { type ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LaunchedView } from '@/components/wizard/launched/launched-view';
import { CampaignLaunchMode } from '@/types/generated/enums';

const searchSchema = z.object({
  job_id: z.string().optional(),
  strategy_id: z.coerce.number().optional(),
  launch_mode: z.nativeEnum(CampaignLaunchMode).optional(),
});

export const Route = createFileRoute('/_authenticated/wizard/launched')({
  validateSearch: searchSchema,
  staticData: { title: 'route.wizard_launched.title' },
  component: LaunchedPage,
});

function LaunchedPage(): ReactElement {
  const { job_id, strategy_id, launch_mode } = Route.useSearch();
  // Re-key on job_id so a retry (new job) remounts the view and resets its
  // subscription/progress state without bespoke reset logic.
  return (
    <LaunchedView
      key={job_id ?? 'no-job'}
      jobId={job_id}
      strategyId={strategy_id}
      launchMode={launch_mode}
    />
  );
}
